const getRequestUrl = fetchInput => typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
export { getRequestUrl };